import { render, staticRenderFns } from "./ReplyItem.vue?vue&type=template&id=7544b9a8&scoped=true&lang=pug&"
import script from "./ReplyItem.vue?vue&type=script&lang=js&"
export * from "./ReplyItem.vue?vue&type=script&lang=js&"
import style0 from "./ReplyItem.vue?vue&type=style&index=0&id=7544b9a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7544b9a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VForm,VImg,VTextarea})
